import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import appMixin from './mixins/app';
import { Http } from './services';
import './components/global';
Vue.config.productionTip = false;

Vue.prototype.$http = Http;

new Vue({
  router,
  store,
  vuetify,
  mixins: [appMixin],
  render: h => h(App),
}).$mount('#app');
